export default "__VITE_ASSET__e6b0c5dd__"